<div class="copy-routine-container">
	<div class="locations-container nice-scroll">
		<locations-list class="locations-list" (locationsChanged)="locations.set($event)" />
	</div>

	<div class="footer">
		<button
			mat-flat-button
			class="copy-button"
			[mat-dialog-close]="locations()"
			[disabled]="!locations().length"
		>
			<span>{{ 'create' | translate }}</span>
		</button>
	</div>
</div>
